
import React, { } from "react";
import { ConfirmModal } from "../..";
import { useAicoConnection } from "../_ToolsComponents/aicoConnectionContext";
import { useMutation } from "@apollo/client";
import { SET_TABLE_CLEAR_QUEUE, SetTableClearQueueArgs, SetTableClearQueueResponse } from "../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/setTableClearQueue";

interface ResetTableProps {
	closeModal: () => void;
	onSuccess: () => void;
	tableId: number
}

export default function ResetTableClearQueueModal({ closeModal, onSuccess, tableId }: ResetTableProps) {
	const { state: connectionState } = useAicoConnection();

	const [resetTableFetch, { data: resetTableData, loading: resetTableLoading, error: resetTableError, reset: resetState }] = useMutation<SetTableClearQueueResponse, SetTableClearQueueArgs>(SET_TABLE_CLEAR_QUEUE, {
		fetchPolicy: "network-only"
	});

	async function handleResetTable() {
		if (!connectionState.deviceConnection) {
			return;
		}

		const result = await resetTableFetch({ variables: { ...connectionState.deviceConnection, tableId: tableId }, });
		if (result.data?.controller.setTableClearQueue?.success) {
			onSuccess();
		}
	}

	function handleCloseModal() {
		resetState();
		closeModal();
	}

	return (
		<ConfirmModal
			disclaimer="This action will reset the table on the LAN Controller to be up to date with the server, and clear the queue for this table, this action is irreversible!"
			onCancel={handleCloseModal}
			onConfirm={handleResetTable}
			message={
				(resetTableError || (resetTableData?.controller && !resetTableData.controller.setTableClearQueue?.success)) ? "ERROR: Failed To Reset Table" :
					(!resetTableLoading && !resetTableError && resetTableData?.controller.setTableClearQueue?.success) ? "Succesfully Added Message To Queue" : undefined
			}
			loading={resetTableLoading}
		/>
	);
}